import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { MpaaInfoModel } from '../../Models/Models/Payments/MPAA/MpaaInfoModel';

declare var IS_RUNNING_IN_APP_POOL;

export class MpaaInfoClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(subAccountHierarchyId: string): Promise<MpaaInfoModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Payments/MpaaInfo/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId }

    return AjaxWrapper.get<MpaaInfoModel, any>(url, data);
  }
}

